<script setup lang="ts">
import { WrapperImageProps } from "~/components/Utils/WrapperImage.props"
import { PasswordConfirmationProps } from "./PasswordConfirmation.props"

const props = withDefaults(
  defineProps<PasswordConfirmationProps & { inModal?: boolean }>(),
  {
    inModal: false
  }
)

const emit =
  defineEmits<{
    (e: "goToLogin"): void
  }>()

const { t } = useI18n()

const handleButtonClick = () => {
  if (props.inModal) {
    emit("goToLogin")
  } else {
    navigateTo("/")
  }
}

const bgImage: WrapperImageProps = getImageData({
  altText: "background image",
  url: "/i5oh5hzamkwo/7730ovBHviXrW6g652dY4Y/1c17692b6d4987f21672938ed40c1316/bg-login.svg",
  width: 1500,
  height: 500
})
</script>

<template>
  <div class="password-confirmation-wrapper md:max-w-[390px]">
    <UtilsWrapperImage
      v-if="bgImage && !props.inModal"
      v-bind="bgImage"
      class="
        wrapper-image-full-container-centered
        absolute
        inset-0
        -z-50
        hidden
        md:block
      "
    />

    <div v-if="!props.inModal">
      <UtilsWrapperImage
        v-if="passwordConfirmationImage"
        v-bind="passwordConfirmationImage"
        class="wrapper-image-full-container-centered md:hidden"
        sizes="xs:1024px sm:1024px"
      />
    </div>

    <div class="flex flex-col gap-4" :class="props.inModal ? 'p-0' : 'p-4'">
      <p class="flex gap-2">
        <UtilsIcon
          name="CheckmarkCircle.svg"
          color="green-main"
          class="h-6 w-6 flex-shrink-0"
        />
        <span class="dolphin-bold">{{
          t("organism.cart.modals.passwordConfirmation.title")
        }}</span>
      </p>

      <UtilsMarkdown
        class="beaver"
        :content="
          t('organism.cart.modals.passwordConfirmation.text', {
            email: props.email
          })
        "
      />

      <UtilsButton
        v-if="!props.inModal"
        :text="t('organism.cart.modals.passwordConfirmation.button')"
        path="/"
      />
      <UtilsButton
        v-else
        :text="t('organism.cart.modals.passwordConfirmation.buttonModal')"
        @click="handleButtonClick()"
      />
    </div>
  </div>
</template>
